import { toast } from "react-toastify";

type ToastType = "error" | "info" | "warning" | "success";

interface arrStr {
  message: string;
  messageKind: number;
}

export const showToastMessage = (
  messages: arrStr[] | string,
  defaultType: ToastType = "error"
) => {
  let messageErr: string[] = [];
  let toastType: ToastType = defaultType;

  if (Array.isArray(messages)) {
    messages.forEach((message) => {
      messageErr.push(message.message);
      switch (message.messageKind) {
        case 1:
          toastType = "info";
          break;
        case 2:
          toastType = "warning";
          break;
        case 3:
        case 4:
        case 5:
          toastType = "error";
          break;
        default:
          toastType = "error";
          break;
      }
    });
  } else {
    messageErr.push(messages);
  }

  if (messageErr.length > 0) {
    const msg = messageErr.join("\r\n");
    toast[toastType](msg, {
      autoClose: false,
      closeButton: true,
      className: "newLineToast",
    });
  }
};
